/*
 * @Autor: zhiying Qin
 * @Date: 2025-03-24 10:22:19
 * @LastEditTime: 2025-09-28 23:05:05
 */
import { get, post } from "@/libs/axios.package";
// import * as AxiosPc from "@/libs/axios.pc";
import { API, ADMIN_API } from "@/libs/const";

//习财圈 所有的api借口js 李先生的开发之路
// export const askList2 = (questionType) => {
//     return post("/question/index",{questionType});
//   };
//获取首页借口
export const getIndex = () => {
  return post("/circle/index/showTopContent");
};
export const getQiniuToken = () => {
  return post("/qiniu/getToken");
};
export const getSupervisorList = (data) => {
  return post("/teacher/getSupervisorList", data);
};
///teacher/register
export const register = (data) => {
  return post("/teacher/register", data);
};

export const studentsave = (data) => {
  return post("/student/studentsave", data);
};
//查询是否填写过
export const getinfo = (data) => {
  return get("/student/info", data);
};

export const getsignStatus = (data) => {
  return post("/student/signStatus", data);
};

export const getCheckCode = (data) => {
  return post("/student/checkCode", data);
};

export const getMajorSelect = (data) => {
  return post("/student/majorSelect", data);
};

// export const getDictType = (type) => {
//   return get("/system/dict/data/type/" + type);
// };

export const postStudentFull = (data) => {
  return post("/student/studentFull", data);
};

export const getDictType = (type) => {
  return get("/type/" + type);
};

export const login = (data) => {
  return post("/login/passwordLogin", data, {baseURL: API + '/pc'});
};

export const postList = (data) => {
  return post("/post/postList", data, {baseURL: API + '/pc'});
};

export const getPostFilter = (data) => {
  return post("/post/getPostFilter", {}, {baseURL: API + '/pc'});
};

export const postCollect = (data) => {
  return post("/post/postCollect", data, {baseURL: API + '/pc'});
};

export const myCollectList = (data) => {
  return post("/post/myCollectList", data, {baseURL: API + '/pc'});
};

export const companyList = (data) => {
  return post("/company/companyList", data, {baseURL: API + '/pc'});
};

export const recentCompanyPostsCounts = (data) => {
  return post("/recentCompanyPosts/counts", data, {baseURL: API + '/pc'});
};

export const recentCompanyPostsStatistics = (data) => {
  return post("/recentCompanyPosts/statistics", data, {baseURL: API + '/pc'});
};

//修改密码
export const updatePassword = (data)=> {
  return post("/pc/login/updatePassword", data, {baseURL: API});
};

export const tokenCheck = (data)=> {
  return post("/login/tokenCheck",data);
};


export const experiencePostList = (data)=> {
  return post("/experience/post/postList",data, {baseURL: API});
};

export const experienceCompanyList = (data)=> {
  return post("/experience/post/companyList",data, {baseURL: API});
};

//根据手机号获取筛选条件无需登陆
export const getUserPostFilter = (data)=> {
  return post("/experience/post/getUserPostFilter",data, {baseURL: API});
};

export const experienceModalCounts = (data)=> {
  return post("/experience/post/counts",data, {baseURL: API});
};

export const experienceModalStatistics = (data)=> {
  return post("/experience/post/statistics",data, {baseURL: API});
};


export const experienceDataList = (data)=> {
  return post("/experience/post/dataList",data, {baseURL: API});
};

export const experienceHeader = (data)=> {
  return post("/experience/post/header",data, {baseURL: API});
};


export const applicationApply = (data)=> {
  return post("/application/apply",data, {baseURL: API + '/pc'});
};


//文职专业下啦
export const majorArmySelect = (data)=> {
  return post("/experience/armyPost/majorArmySelect",data, {baseURL: API});
};



export const armyPostList = (data)=> {
  return post("/experience/armyPost/postList",data, {baseURL: API});
};

export const armyPostGetPostFilter = (data)=> {
  return post("/experience/armyPost/getPostFilter",data, {baseURL: API});
};


export const authorityList = (data)=> {
  return post("/select/authority",data, {baseURL: ADMIN_API});
};

export const armyPostCollect = (data)=> {
  return post("/experience/armyPost/postCollect",data, {baseURL: API});
};

export const postFullInfo = (data)=> {
  return post("/experience/post/fullInfo",data, {baseURL: API});
};


export const postGetLinkCode = (data)=> {
  return post("/experience/post/getLinkCode",data, {baseURL: API});
};


// export const studentFull = (data) => {
//   return post("/student/studentFull", data, {baseURL: API + '/pc'});
// };
// /api
